module.exports = __webpack_public_path__ + "ddc41f22c7c4682ffe4d5fb4fea75481.pdf";